import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { logoutUser, setPremiumStatus } from "../../store/actions/auth";

import { Box, styled, useTheme, Avatar, useMediaQuery } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { ReactComponent as HomeIcon } from "./../../assets/homeIcon.svg";

import {
  IoCashOutline,
  IoGridOutline,
  IoPeopleOutline,
  IoPersonOutline,
  IoReaderOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import MenuIcon from "@mui/icons-material/Menu";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { GoHome, GoVersions, GoCodeOfConduct } from "react-icons/go";
import "./navigation.scss";
import MenuButton from "./MenuButton";
import logo from "../../assets/logo.png";

import { MdPersonAdd, MdPersonRemove } from "react-icons/md";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { db } from "../../firebase/firebase-config";

const drawerWidth = 225;
const miniDrawerWidth = 64;
const MySwal = withReactContent(Swal);
const Sidebar = ({
  handleDrawerToggle,
  opened,
  open,
  mobileVerticalDrawerOpen,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { premiumStatus, adminData } = useSelector((state) => state.auth);
  const { sponsor } = useSelector((state) => state.sponsor);
  const navigate = useNavigate();
  const navigateTo = (link) => {
    navigate(link);
  };
  useEffect(() => {
    //console.log(sponsor, sponsor.email);
    if (sponsor && sponsor.email) {
      // Listen to changes in the premium status of the admin
      const unsubscribe = db
        .collection("sponsors")
        .where("email", "==", sponsor.email)
        .onSnapshot((snapshot) => {
          snapshot.forEach((doc) => {
            const data = doc.data();
            console.log(data);
            if (data.tier === "elite") {
              dispatch(setPremiumStatus("elite"));
            } else if (data.tier === "premium") {
              dispatch(setPremiumStatus("premium"));
            } else {
              dispatch(setPremiumStatus("basic"));
            }
          });
        });
      console.log(premiumStatus);
      // Unsubscribe from premium status changes
      return () => unsubscribe();
    }
  }, [sponsor, dispatch]);

  const handleLogout = async () => {
    const confirmResult = await MySwal.fire({
      title: "¿Estás seguro de que quieres cerrar la sesión?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Volver",
      confirmButtonText: "Sí",
      reverseButtons: true,
    });

    if (confirmResult.isConfirmed) {
      dispatch(logoutUser());
      navigate("/auth/login", { replace: true });
    } else {
    }
  };
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const tablet = useMediaQuery(theme.breakpoints.down("lg"));
  const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),

    overflowX: "hidden",
  });

  const closedMixin = (theme) => ({
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(${theme.spacing(6)} + 1px)`,
    },
  });

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

  const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",

    boxSizing: "border-box",
    ...(open && {
      ...openedMixin(theme),
      "& .MuiDrawer-paper": openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      "& .MuiDrawer-paper": closedMixin(theme),
    }),
  }));

  const drawer = (
    <Drawer
      variant={"permanent"}
      open={open}
      sx={
        tablet
          ? {
              "& .MuiPaper-root": {
                backgroundColor: "#fbfafc !important",
                height: " 65vh !important",
                marginLeft: "1.5em",
                mt: 10,
                borderRadius: "18px",
                borderWidth: "1px !important",
                border: "solid",
                borderColor: "#ECECEE",
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,rgba(0, 0, 0, 0.06) 0px 2px 4px -1px !important;",
              },
            }
          : {
              "& .MuiPaper-root": {
                backgroundColor: "#fbfafc !important",
                height: " 65vh !important",
                marginLeft: "1.5em",
                mt: 10,
                borderRadius: "18px",
                borderWidth: "1px !important",
                border: "solid",
                borderColor: "#ECECEE",
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,rgba(0, 0, 0, 0.06) 0px 2px 4px -1px !important;",
              },
            }
      }
    >
      <DrawerHeader>
        <Box
          component={"a"}
          id="sidebar"
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            width: "175px",
          }}
          onClick={() => navigateTo("/")}
        >
          {open && (
            <img
              src={logo}
              alt="Home"
              style={{ width: "75%", height: "auto" }}
            />
          )}
        </Box>

        <IconButton
          onClick={handleDrawerToggle}
          sx={{ color: theme.palette.primary.main }}
        >
          {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </DrawerHeader>

      <List>
        <MenuButton
          item={{ title: "Inicio", icon: <HomeIcon />, route: "/home" }}
          open={open}
        />

        <MenuButton
          item={{
            title: "Mi Perfil",
            icon: <IoPeopleOutline size={25} className="inactive-icon" />,
            route: "/profile",
          }}
          open={open}
        />
        <MenuButton
          item={{
            title: "Canjes",
            icon: <GoVersions size={25} className="inactive-icon" />,
            route: "/exchanges",
          }}
          open={open}
        />
        <MenuButton
          item={{
            title: "Descuentos",
            icon: <IoGridOutline size={25} className="inactive-icon" />,
            route: "/discounts",
          }}
          open={open}
        />
        <MenuButton
          item={{
            title: "Redenciones",
            icon: <IoCashOutline size={25} className="inactive-icon" />,
            route: "/redeems",
          }}
          open={open}
        />
        <MenuButton
          item={{
            title: "Blog",
            icon: <IoReaderOutline size={25} className="inactive-icon" />,
            route: "/posts",
          }}
          open={open}
          disabled={premiumStatus === "basic"}
        />
        <MenuButton
          item={{
            title: "Consultas",
            icon: <IoReaderOutline size={25} className="inactive-icon" />,
            route: "/inquiries",
          }}
          open={open}
        />

        {/* <MenuButton
          item={{
            title: "Configuración",
            icon: <IoSettingsOutline size={25} className="inactive-icon" />,
            route: "/settings",
          }}
          open={open}
        /> */}
      </List>
      <Box style={{ flexGrow: 1 }} />

      <List>
        <ListItem
          onClick={handleLogout}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
            cursor: "pointer",
          }}
        >
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText primary="Cerrar sesión" />
        </ListItem>
      </List>
    </Drawer>
  );

  //Mobile menu
  const mobileDrawer = (
    <Drawer
      variant={"permanent"}
      open={false}
      sx={{
        "& .MuiPaper-root": {
          position: "absolute",
          backgroundColor: "#fbfafc !important",
          height: " 490px !important",
          marginLeft: "1.5em",
          marginTop: "3em",
          boxShadow:
            "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,rgba(0, 0, 0, 0.06) 0px 2px 4px -1px !important;",
        },
      }}
    >
      <List>
        <MenuButton
          item={{ title: "Inicio", icon: <HomeIcon />, route: "/home" }}
          open={false}
          handleDrawerToggle={handleDrawerToggle}
        />
        <MenuButton
          item={{
            title: "Mi perfil",
            icon: <IoReaderOutline size={25} className="inactive-icon" />,
            route: "/profile",
          }}
          handleDrawerToggle={handleDrawerToggle}
          open={false}
        />
        <MenuButton
          item={{
            title: "Tus Usuarios",
            icon: <GoVersions size={25} className="inactive-icon" />,
            route: "/exchanges",
          }}
          handleDrawerToggle={handleDrawerToggle}
          open={false}
        />
        <MenuButton
          item={{
            title: "Descuentos",
            icon: <IoGridOutline size={25} className="inactive-icon" />,
            route: "/discounts",
          }}
          handleDrawerToggle={handleDrawerToggle}
          open={false}
        />
        <MenuButton
          item={{
            title: "Redenciones",
            icon: <IoCashOutline size={25} className="inactive-icon" />,
            route: "/redeems",
          }}
          handleDrawerToggle={handleDrawerToggle}
          open={false}
        />

        <MenuButton
          item={{
            title: "Blogs",
            icon: <IoReaderOutline size={25} className="inactive-icon" />,
            route: "/blogs",
          }}
          handleDrawerToggle={handleDrawerToggle}
          open={false}
        />
        <MenuButton
          item={{
            title: "Consultas",
            icon: <IoReaderOutline size={25} className="inactive-icon" />,
            route: "/inquiries",
          }}
          handleDrawerToggle={handleDrawerToggle}
          open={false}
        />
        {/* <MenuButton
          item={{
            title: "Configuración",
            icon: <IoSettingsOutline size={25} className="inactive-icon" />,
            route: "/settings",
          }}
          open={open}
        /> */}
      </List>
      <Box style={{ flexGrow: 1 }} />

      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <List>
          <ListItem
            onClick={handleLogout}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,

                justifyContent: "center",
              }}
            >
              <ExitToAppIcon />
            </ListItemIcon>
            {/* <ListItemText primary="Cerrar sesión" /> */}
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );

  return (
    <Box sx={{ display: "flex" }}>
      {mobile ? (
        <>
          {!mobileVerticalDrawerOpen ? (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerToggle}
              sx={{
                zIndex: theme.zIndex.drawer + 1,
                color: theme.palette.primary.main,
              }}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerToggle}
                sx={{ zIndex: theme.zIndex.drawer + 1 }}
              >
                <MenuIcon />
              </IconButton>
              {mobileDrawer}
            </>
          )}
        </>
      ) : (
        drawer
      )}
    </Box>
  );
};

export default Sidebar;
